<template>
  <div class="App">
    <AppHeader v-model="open" />
    <b-sidebar
      type="is-white"
      :fullheight="true"
      :overlay="true"
      :open.sync="open.menu"
    >
      <div class="SidebarNav">
        <img src="/img/leonisa.svg" alt="Leonisa" width="112" height="28">
      </div>
      <div class="p-1 sidebar-content">
        <AppSidebar />
      </div>
    </b-sidebar>
    <b-sidebar
      type="is-white"
      :fullheight="true"
      :overlay="true"
      :open.sync="open.cart"
      :right="true"
      :canCancel="false"
    >
      <div class="SidebarNav">
        <div class="level is-mobile">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <b-button type="is-success" icon-left="file-download" @click="$refs.AppCart.export()">
                Descargar
              </b-button>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right">
            <div class="level-item">
              <button type="button" class="delete" @click="open.cart = !open.cart"/>
            </div>
          </div>
        </div>
      </div>
      <div class="p-1 sidebar-content">
        <AppCart ref="AppCart" />
      </div>
    </b-sidebar>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AppCart from '@/components/AppCart'
export default {
  components: {
    AppHeader,
    AppSidebar,
    AppCart
  },
  data() {
    return {
      open: {
        menu: false,
        cart: false
      },
      brands: [],
      categories: {},
      bracup: {},
      colors: []
    }
  },
  watch: {
    open (data) {
      console.log(data)
    }
  },
  mounted () {
    this.$http.get('catalog.json').then((response) => {
      console.log(response.data)
      this.processCatalog(response.data)
    })
  },
  methods: {
    ...mapActions([
      'setCatalog',
      'setFilter'
    ]),
    processCatalog (data) {
      var instance = this
      var brands = []
      var colors = []
      var categories = []
      var bracup = {}
      var catalog = data.filter(product => {
        return product.title.toLowerCase() !== 'sin información en channel'
      }).map(product => {
        brands.push({brand: product.brand})
        product.categories = product.categories.trim()
        categories.push(product.categories)
        product['colorGroup'] = product.colors.filter(color => {
          if (color.sizes.length) {
            product.colors.map(color => color.sizes.map(size => {
              if (!/^\s*$/.test(size.cup) && !(size.cup.trim() in bracup)) {
                bracup[size.cup.trim()] = 0
              }
            }))
          }

          if (color.colorSW.toLowerCase() !== 'sin imagen en channel') {
            colors.push(color)
            return color
          }
          return false
        })
        return product
      })

      instance.setCatalog(catalog)

      Object.keys(bracup).map(cup => {
        bracup[cup] = catalog.filter(product => product.colors.filter(color => color.sizes.filter(size => size.cup.trim() === cup).length).length).length
      })

      instance.brands = [...new Map([].concat.apply([], brands).map(item => [item.brand, item])).values()]
      instance.colors = [...new Map([].concat.apply([], colors).map(item => [item.colorCode, item])).values()]

      instance.categories = categories.reduce(function(prev, cur) {
        prev[cur] = (prev[cur] || 0) + 1;
        return prev;
      }, {})

      instance.bracup = bracup

      console.log('App brands', instance.brands)
      console.log('App colors', instance.colors)
      console.log('App categories', instance.categories)
      console.log('App bracup', instance.bracup)

      instance.setFilter({
        key: 'brands',
        value: instance.brands
      })
      instance.setFilter({
        key: 'colors',
        value: instance.colors
      })
      instance.setFilter({
        key: 'categories',
        value: instance.categories
      })
      instance.setFilter({
        key: 'bracup',
        value: instance.bracup
      })
    }
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  font-weight: 300;
}

// Bulma customize
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Body
$body-background-color: #fff;

$family-sans-serif: 'Roboto', sans-serif;
$weight-normal: 300;
$weight-bold: 400;

$blue: #007bff;
$red: #dc3545;
$green: #28a745;
$turquoise: #00A98E;
$yellow: #ffc107;
$grey-darker: #2c2a29;
$grey-darklight: #6c757d;


$primary: $blue;
$primary-invert: findColorInvert($primary);

$link: $cyan;
$link-invert: findColorInvert($link);

$info: $cyan;
$info-invert: findColorInvert($info);

$success: $green;
$success-invert: findColorInvert($success);

$warning: $yellow;
$warning-invert: findColorInvert($warning);

$danger: $red;
$danger-invert: findColorInvert($danger);

$dark: $grey-darker;
$dark-invert: findColorInvert($dark);

$darklight: $grey-darklight;
$darklight-invert: findColorInvert($darklight);

$text: $grey-dark;
$text-invert: findColorInvert($text);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
// $colors: (
//   "white": ($white, $black),
//   "black": ($black, $white),
//   "light": ($light, $light-invert),
//   "dark": ($dark, $dark-invert),
//   "darklight": ($darklight, $darklight-invert),
//   "primary": ($primary, $primary-invert),
//   "info": ($info, $info-invert),
//   "success": ($success, $success-invert),
//   "warning": ($warning, $warning-invert),
//   "danger": ($danger, $danger-invert)
// );

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Navbar
// $navbar-background-color: #194237;
// $navbar-height: 4.5rem;

// $sidebar-box-shadow: none;
// $sidebar-background: #fff;

// .dropdown {
//   &.is-fullwidth {
//     width: 100%;
//     .dropdown-trigger {
//       width: 100%;
//     }
//     .button {
//       width: 100%;
//     }
//     .dropdown-arrow {
//       top:50%;
//       transform: translateY(-50%);
//       right: 20px;
//       position: absolute;
//     }
//     .dropdown-menu {
//       width: calc(100% - 2px);
//     }
//   }
// }

// .dropdown {
//   &.is-dropdown-menu-collapsed {
//     .dropdown-menu {
//       min-width: auto;
//     }
//   }
// }

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// .darkClose .modal-close {
//   background-color: rgba(0, 0, 0, 0.3);
//   &:hover {
//     background-color: rgba(0, 0, 0, 0.5);
//   }
// }
.darkClose .modal-content {
  background: #f5f5f5;
  border-radius: 7px;
}
.darkClose .modal-content .section {
  padding: 1.5rem 1.5rem;
}

.SidebarNav {
  background-color: black;
  height: 52px;
  padding: .4rem;
}
.sidebar-content {
  position: absolute;
  top: 52px;
  bottom: 0;
  overflow: auto;
}
button.has-tag:after {
  background-color: #007bff;
  border-radius: 290486px;
  color: #fff;
  content: attr(data-tag) " ";
  font-size: .6rem;
  height: auto;
  padding: 1px 5px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>
